var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"flex items-center justify-center gap-2 whitespace-pre-line leading-[normal]",class:[
    _vm.disabled ? '!bg-grayG0 border-0 !text-white' : ("!bg-white " + _vm.hoverBorderColor + " " + _vm.hoverBgColor + " " + _vm.hoverTextColor),
    _vm.textStyle,
    _vm.borderColor,
    _vm.borderRadius,
    _vm.padding,
    _vm.width,
    _vm.height
  ],attrs:{"disabled":_vm.disabled},on:{"click":function () {
      if (_vm.onClick) { _vm.onClick(); }
    }}},[_c('div',{staticClass:"flex items-center justify-center",class:_vm.gap},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }